export default function MurfreesboroMistakesSection() {
  const mistakes = [
    {
      icon: "ri-time-line",
      title: "Waiting Too Long Before Study Abroad",
      description:
        "MTSU students frequently wait until their program acceptance letter arrives to start the passport process. By then, there may be only 4-6 weeks until departure.",
      fix: "Apply for your passport as soon as you start researching study abroad options — not after acceptance.",
    },
    {
      icon: "ri-camera-line",
      title: "Non-Compliant Photos",
      description:
        "Passport photos with glasses, off-center composition, or incorrect background cause automatic rejection. Self-taken or convenience store photos often fail.",
      fix: "Use our professional passport photo service to guarantee compliance the first time.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Driving to Nashville for Nothing",
      description:
        "Atlanta Passport Agency appointments along I-24 are frequently sold out. Murfreesboro residents drive 35 miles only to find nothing available.",
      fix: "Call us first. We eliminate the 70-mile round trip and guarantee your timeline.",
    },
    {
      icon: "ri-id-card-line",
      title: "Incomplete Document Packages",
      description:
        "Missing a birth certificate copy, wrong identification, or incomplete DS-11 forms cause automatic rejection and restart the clock on your timeline.",
      fix: "We review your complete document package before submission — nothing gets rejected.",
    },
    {
      icon: "ri-file-damage-line",
      title: "Using the Wrong Form",
      description:
        "DS-11 vs DS-82 is confusing for first-time applicants and people who haven't renewed in years. Using the wrong form wastes 2-3 weeks.",
      fix: "Our experts determine the right form based on your situation before you waste a submission.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "Missing the 6-Month Validity Rule",
      description:
        "Study abroad destinations in Europe and Asia often require passports valid 6 months beyond your return date. Many students get stranded at the airport.",
      fix: "We check your expiration date against your destination requirements before processing.",
    },
  ];

  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Common Mistakes</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Mistakes Murfreesboro Travelers Make
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            We've seen every possible passport mistake. Here are the most common ones we prevent for MTSU students and Rutherford County families.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mistakes.map((mistake, index) => (
            <div key={index} className="bg-white rounded-xl p-7">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-red-50 mb-5">
                <i className={`${mistake.icon} text-red-400 text-xl`}></i>
              </div>
              <h3 className="font-serif text-lg font-bold text-[#1A365D] mb-3">{mistake.title}</h3>
              <p className="text-gray-500 text-sm leading-relaxed mb-4">{mistake.description}</p>
              <div className="flex items-start gap-2 bg-[#F7F8FA] p-3 rounded-lg">
                <i className="ri-lightbulb-line text-[#F6C344] text-sm mt-0.5 flex-shrink-0"></i>
                <p className="text-gray-600 text-xs leading-relaxed">{mistake.fix}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}